import _ from 'lodash';
import { connect } from 'react-redux';

import { subscriptions } from 'app/selectors/subscriptions';
import ChangeAccessDialog from 'app/components/settings/change-access-dialog';

const mapStateToProps = state => ({
  isSubscriptionsEnabled: subscriptions.isEnabled(state),
  isSubscriber: subscriptions.isSubscriber(state),
  subscription: subscriptions.current(state),
  addedUsers: subscriptions.getAddedUsers(state),
  totalUsers: subscriptions.getTotalUsers(state),
});

const ChangeAccessDialogContainer = connect(
  mapStateToProps)(ChangeAccessDialog);

export default ChangeAccessDialogContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/change-access-dialog.js